import { cloneDeep } from 'lodash';

export default {
  setMoreFamilyList: (state, list) => {
    state.familyList = list;
  }
};
